let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3qAIr")).then(() => parcelRequire('iqS01'));